module.exports = __webpack_public_path__ + "static/media/ipad-content-2.5378bd93.png";